import React, { useEffect } from 'react';
import { useLanguage } from '../../../../hooks/useLanguage';
import { aside as frAside } from '../../../../locales/fr/aside';
import { aside as arAside } from '../../../../locales/ar/aside';
import { aside as esAside } from '../../../../locales/es/aside';
import useMyAppStore from '../../../../stores/myAppStore';

const translations = {
  fr: frAside,
  ar: arAside,
  es: esAside
};

const ModelesVente = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const { setPageTitle } = useMyAppStore();

  useEffect(() => {
    setPageTitle(t.routes.salesModels);
  }, [lang, t.routes.salesModels, setPageTitle]);

  return (
    <div className="container mx-auto">
      <h1 className="text-2xl font-bold mb-4">Gestion des Modèles de Vente</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <p>Liste des modèles de vente à venir...</p>
      </div>
    </div>
  );
};

export default ModelesVente; 